import { render, staticRenderFns } from "./DetailFooterButtons.vue?vue&type=template&id=23626aaa&scoped=true"
import script from "./DetailFooterButtons.vue?vue&type=script&lang=js"
export * from "./DetailFooterButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23626aaa",
  null
  
)

export default component.exports